<template>
  <div>
    <v-overlay :opacity="1" :value="overlay" class="default_overlay">
      <Loading />
    </v-overlay>
    <v-app>
      <v-main>
        <slot />
      </v-main>
      <ErrorModal />
      <UnsupportedBrowserModal id="unsupported-browser-modal" />
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'RegionSelectorLayout',
  data() {
    return {
      overlay: true
    };
  },
  mounted() {
    this.overlay = false;
  }
};
</script>

<style lang="scss">
body .v-overlay--active.default_overlay {
  .v-overlay__scrim {
    opacity: 1 !important;
    background-color: $white !important;
    border-color: $white !important;
  }
}
</style>
